module.exports = "/_next/static/images/1b7ae58d50274b9e36d080cd06bdc447-gift-illustration@1x.png";